import { render, staticRenderFns } from "./channelAccountDetails.vue?vue&type=template&id=2624f012&scoped=true&"
import script from "./channelAccountDetails.vue?vue&type=script&lang=js&"
export * from "./channelAccountDetails.vue?vue&type=script&lang=js&"
import style0 from "./channelAccountDetails.vue?vue&type=style&index=0&id=2624f012&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2624f012",
  null
  
)

export default component.exports